module.exports = __webpack_public_path__ + "static/media/upArrow.f92afb85.svg";